module.exports = __webpack_public_path__ + "media/favorite_job_offers/btn_favorite-default-b8015e96.svg";